import React from 'react';
import "../Styles/Stats.css"
const Stats = () => {
    return (
        <div >
            <div id="cn">
                <a href="https://github.com/chintasiva">
                    <img className='stats1' 
                     src="https://github-readme-streak-stats.herokuapp.com?user=chintasiva&theme=dark&border_radius=10" 
                     alt=""
                      />
                </a>
            </div>
            {/* style={{
                margin:"auto",
                display:'flex',
                width:"55%",
                height:"300px",
                justifyContent:"space-between",
                alignItems:"center"
            }} */}
            <div className='stats2' >
                <a href="https://github.com/chintasiva">
                    <div data-aos="flip-right" >
                    <img id="first" src="https://github-readme-stats.vercel.app/api/top-langs/?username=chintasiva&langs_count=8&theme=dark"
                     alt="" 
                     />
                    </div>
                    
                </a>
                <a href="https://github.com/chintasiva" data-aos="flip-left">
                    <img id="second" src="https://github-readme-stats.vercel.app/api?username=chintasiva&show_icons=true&count_private=true&theme=dark"
                     alt="" />
                </a>
            </div>
        </div>
    );
}

export default Stats;